export default {
  address: 'Adresă',
  contact: 'Contact',
  terms: 'Termeni de utilizare',
  privacy_policy: 'Politica de confidențialitate',
  impressum: 'Impressum',
  cookie_policy: 'Politica de cookie-uri',
  cookie_settings: 'Setări cookie-uri',
};
